import { Window } from '@mui/icons-material';
import {useEffect} from 'react'
import { useLocation } from 'react-router-dom'

const ScrollTop = () => {
    const {pathname}=useLocation();
    useEffect(()=>{
        document.getElementById('root').scrollIntoView({behavior:'smooth'})
    },[pathname])
}

export default ScrollTop